import { createNizzaLogger } from '@nizza/core';

const logger = createNizzaLogger('backoffice-front');

export default logger;
